import { render, staticRenderFns } from "./classifySelect.vue?vue&type=template&id=7482069c&scoped=true"
import script from "./classifySelect.vue?vue&type=script&lang=js"
export * from "./classifySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7482069c",
  null
  
)

export default component.exports